import styled from 'styled-components';

export const Background = styled.section`
  background-color: #fafafa;
  min-height: 100vh;
`;

export const TitleWrapper = styled.div`
  h1 {
    top: 4em;
  }
`;
